import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';
import { RowData } from './datapoints';

export type EditedStoreFamilyClusterDatapointsState = Record<string, Partial<RowData>>;

const initialState: EditedStoreFamilyClusterDatapointsState = {};

const slice = createSlice({
  name: 'getStoreFamilyClusterModal/editedStoreFamilyClusterDatapoints',
  initialState,
  reducers: {
    SET_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS: (_state, { payload }: PayloadAction<EditedStoreFamilyClusterDatapointsState>) => payload,

    UPDATE_EDITED_STORE_FAMILY_CLUSTER_DATAPOINT: (
      state,
      {
        payload,
      }: {
        payload: {
          key: string;
          updatedData: Partial<RowData>;
        };
      },
    ) => {
      state[payload.key] = {
        ...state[payload.key],
        ...payload.updatedData,
      };
    },
    CLEAR_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS: () => initialState,
  },
});

export const { SET_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS, UPDATE_EDITED_STORE_FAMILY_CLUSTER_DATAPOINT, CLEAR_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS } =
  slice.actions;

export const selectorGetEditedStoreFamilyClusterDatapoints = (state: RootState) => state.getStoreFamilyClusterModalReducer.editedStoreFamilyClusterDatapoints;

export default slice.reducer;
